export const notIframe = window === window.parent;
